// Localized SEO description + FAQ for each Free Tool (ES / ZH / VI).
// English lives in toolsSeo.js; these are used so tool pages rank in each language.
export const TOOL_SEO_LOCALES = {
  es: {
    "a1c-to-glucose": {
      desc: "Calculadora gratuita de A1C a glucosa promedio (eAG). Descubre qué significa tu A1C para tu azúcar en sangre diaria, en lenguaje sencillo. Privada e instantánea.",
      faq: [
        { q: "¿Qué es la glucosa promedio estimada (eAG)?", a: "La eAG convierte tu porcentaje de A1C en el número promedio de azúcar en sangre (mg/dL o mmol/L) que refleja los últimos 2 a 3 meses, para que sea más fácil de comparar con tus lecturas en casa." },
        { q: "¿Un A1C más bajo siempre es mejor?", a: "Suele indicar mejor control a largo plazo, pero las metas son personales. Números muy bajos pueden significar hipoglucemia. Habla con tu médico sobre tu A1C objetivo." },
      ],
    },
    "glucose-to-a1c": {
      desc: "Estimador gratuito de azúcar en sangre a A1C. Convierte tu glucosa promedio en un porcentaje aproximado de A1C. Educativo, privado e instantáneo.",
      faq: [
        { q: "¿Puedo reemplazar un A1C de laboratorio con esta estimación?", a: "No. Es una estimación educativa a partir de tu glucosa promedio; el A1C de laboratorio medido en sangre es el valor exacto que usa tu médico." },
        { q: "¿Qué glucosa promedio debo usar?", a: "Usa el promedio de muchas lecturas a distintas horas del día para una mejor estimación; una sola lectura no es representativa." },
      ],
    },
    "bmi": {
      desc: "Calculadora gratuita de IMC con unidades de EE. UU. y métricas. Encuentra tu índice de masa corporal y su categoría de peso, explicado de forma sencilla.",
      faq: [
        { q: "¿El IMC es preciso para todos?", a: "El IMC es un tamizaje rápido, no una medida de grasa corporal. Las personas muy musculosas pueden salir altas y no indica dónde se almacena la grasa. Úsalo junto con otras medidas." },
        { q: "¿Cuál es un IMC saludable?", a: "Para la mayoría de los adultos, 18.5 a 24.9 se considera el rango normal, pero un peso saludable depende de tu salud general; consulta a tu médico." },
      ],
    },
    "blood-pressure": {
      desc: "Verificador gratuito de categoría de presión arterial (ACC/AHA). Ingresa tu sistólica y diastólica para ver qué significa tu lectura y qué hacer.",
      faq: [
        { q: "¿Cuál es una presión arterial normal?", a: "Menos de 120/80 mmHg se considera normal para la mayoría de los adultos. 120–129 de sistólica es 'elevada', y 130/80 o más es presión alta." },
        { q: "Una lectura alta, ¿debo preocuparme?", a: "Una sola lectura puede verse afectada por el estrés, la cafeína o la actividad. Vuelve a medir en calma; si sigue alta o te sientes mal, contacta a tu médico." },
      ],
    },
    "egfr": {
      desc: "Calculadora gratuita de función renal eGFR con la ecuación CKD-EPI 2021 sin raza. Estima la función renal a partir de creatinina, edad y sexo.",
      faq: [
        { q: "¿Qué me dice la eGFR?", a: "Estima qué tan bien filtran la sangre tus riñones. Más alto suele ser mejor; un solo valor no es un diagnóstico: la salud renal se evalúa con el tiempo." },
        { q: "¿Por qué no se usa la raza?", a: "La ecuación CKD-EPI de 2021 no usa la raza, siguiendo las guías actuales para que las estimaciones sean más justas y consistentes." },
      ],
    },
    "creatinine-clearance": {
      desc: "Calculadora gratuita de aclaramiento de creatinina (Cockcroft-Gault) a partir de edad, peso, creatinina y sexo. Estimación educativa de función renal y dosis.",
      faq: [
        { q: "¿En qué se diferencia de la eGFR?", a: "Cockcroft-Gault usa tu peso corporal real y suele emplearse para dosificar medicamentos, mientras que la eGFR se estandariza al tamaño corporal para clasificar la enfermedad renal." },
        { q: "¿Qué peso debo ingresar?", a: "Esta herramienta usa el peso corporal real. Los profesionales pueden ajustar según el tamaño corporal al usar el resultado para dosificar." },
      ],
    },
    "cholesterol-risk": {
      desc: "Herramienta gratuita de riesgo de colesterol: mira tu relación colesterol total/HDL y factores comunes de riesgo cardíaco, en lenguaje sencillo.",
      faq: [
        { q: "¿Cuál es una buena relación total/HDL?", a: "Más baja es mejor. Menos de 3.5 aproximadamente es favorable; relaciones más altas sugieren más riesgo cardiovascular. Es una señal, no un puntaje completo." },
        { q: "¿Esto da mi riesgo ASCVD?", a: "No. Para una estimación formal del riesgo cardíaco a 10 años, pregunta a tu médico por la calculadora ASCVD, que usa más de tus datos de salud." },
      ],
    },
    "ldl": {
      desc: "Calculadora gratuita de colesterol LDL con la fórmula de Friedewald a partir de colesterol total, HDL y triglicéridos. Educativa e instantánea.",
      faq: [
        { q: "¿Cuándo no es válida la LDL de Friedewald?", a: "Se vuelve poco fiable cuando los triglicéridos son de 400 mg/dL (4.5 mmol/L) o más. En ese caso pide una LDL medida directamente." },
        { q: "¿Qué LDL debo buscar?", a: "Las metas dependen de tu riesgo cardíaco general. Muchas personas buscan menos de 100 mg/dL, y menos si tienen mayor riesgo; habla con tu médico." },
      ],
    },
    "non-hdl": {
      desc: "Calculadora gratuita de colesterol no-HDL a partir del colesterol total y HDL. Un objetivo de tratamiento útil que capta todo el colesterol 'malo'.",
      faq: [
        { q: "¿Por qué es útil el no-HDL?", a: "Capta cada partícula de colesterol que puede acumularse en las arterias, no solo la LDL, por lo que puede ser un mejor objetivo, sobre todo con triglicéridos altos." },
        { q: "¿Cómo se calcula?", a: "El colesterol no-HDL es simplemente tu colesterol total menos tu colesterol HDL ('bueno')." },
      ],
    },
    "target-heart-rate": {
      desc: "Calculadora gratuita de frecuencia cardíaca objetivo. Encuentra tus zonas de ejercicio moderado y vigoroso por edad (con el método Karvonen opcional).",
      faq: [
        { q: "¿Cómo se calculan las zonas?", a: "La frecuencia máxima se estima como 220 menos tu edad. Moderada es 50–70% y vigorosa 70–85%. Añadir tu frecuencia en reposo usa el método más personal de Karvonen." },
        { q: "¿Estas zonas son exactas?", a: "No: son estimaciones según la edad. Importan tu estado físico, medicamentos y condiciones. Reduce el ritmo o detente si te sientes mal." },
      ],
    },
    "due-date": {
      desc: "Calculadora gratuita de fecha de parto con la regla de Naegele desde tu última regla. Estima tu fecha probable y semanas de embarazo al instante.",
      faq: [
        { q: "¿Cómo se estima la fecha de parto?", a: "Suma 280 días (40 semanas) al primer día de tu última regla, asumiendo un ciclo de 28 días. Una ecografía da una fecha más precisa." },
        { q: "¿Qué tan exacta es?", a: "Es una buena estimación para ciclos regulares, pero solo 1 de cada 20 bebés nace exactamente en la fecha. Tu médico puede ajustarla tras una ecografía." },
      ],
    },
    "medication-dose": {
      desc: "Calculadora gratuita de dosis por peso (mg/kg) con tope opcional de dosis máxima. Solo matemáticas educativas: confirma siempre con un profesional.",
      faq: [
        { q: "¿Es seguro dosificar medicina real con esto?", a: "Son cálculos generales de mg/kg solo con fines educativos. Confirma siempre el fármaco, dosis, frecuencia y producto con un farmacéutico o médico antes de administrar." },
        { q: "¿Qué hace la dosis máxima?", a: "Si ingresas un tope por dosis, el resultado no lo superará: útil para medicinas con un límite sin importar el peso." },
      ],
    },
    "ideal-body-weight": {
      desc: "Calculadora gratuita de peso corporal ideal (fórmula de Devine) a partir de la estatura y el sexo. Una referencia clínica aproximada, en kg y lb.",
      faq: [
        { q: "¿Para qué sirve el peso corporal ideal?", a: "Es una referencia aproximada usada en algunas dosis y estimaciones clínicas. El peso saludable real varía según la complexión, el músculo y la composición corporal." },
        { q: "¿Debo apuntar a este número exacto?", a: "No necesariamente: es una estimación por fórmula, no una meta personal. Habla con tu médico sobre un rango de peso saludable." },
      ],
    },
    "waist-height-ratio": {
      desc: "Calculadora gratuita de relación cintura-estatura (WHtR): una revisión rápida de la grasa central y el riesgo cardíaco según tu cintura y estatura.",
      faq: [
        { q: "¿Cuál es una relación cintura-estatura saludable?", a: "Mantener tu cintura por debajo de la mitad de tu estatura (una relación menor de 0.5) es una meta sencilla y muy usada para la salud del corazón." },
        { q: "¿Por qué medir la cintura y no solo el IMC?", a: "El tamaño de la cintura refleja la grasa alrededor de los órganos, que conlleva más riesgo. La WHtR aporta información que el IMC puede pasar por alto." },
      ],
    },
    "pediatric-fever": {
      desc: "Calculadora gratuita de dosis para la fiebre infantil (acetaminofén e ibuprofeno) por peso, ahora con concentraciones comunes para obtener los mL exactos.",
      faq: [
        { q: "¿Cuánto acetaminofén o ibuprofeno puedo darle a mi hijo?", a: "La dosis es por peso (unos 15 mg/kg de acetaminofén, 10 mg/kg de ibuprofeno). Elige la concentración de tu producto para ver los mL exactos y confírmalo con tu pediatra o farmacéutico." },
        { q: "¿Cómo mido el líquido?", a: "Usa siempre la jeringa o el vaso que viene con el medicamento, nunca una cuchara de cocina, y no combines productos con el mismo fármaco." },
      ],
    },
  },

  zh: {
    "a1c-to-glucose": {
      desc: "免费的 A1C 转平均血糖（eAG）计算器。用通俗易懂的语言了解你的 A1C 对日常血糖意味着什么。私密、即时。",
      faq: [
        { q: "什么是估计平均血糖（eAG）？", a: "eAG 把你的 A1C 百分比换算成它所反映的过去 2–3 个月的平均血糖数值（mg/dL 或 mmol/L），更方便与家用血糖读数对照。" },
        { q: "A1C 越低总是越好吗？", a: "通常意味着更好的长期控制，但目标因人而异。数值过低可能代表低血糖。请与医生讨论你的目标 A1C。" },
      ],
    },
    "glucose-to-a1c": {
      desc: "免费的血糖转 A1C 估算器。把平均血糖换算成大致的 A1C 百分比。仅供教育参考，私密、即时。",
      faq: [
        { q: "可以用这个估算代替化验的 A1C 吗？", a: "不可以。这是根据平均血糖得出的教育性估算；抽血化验的 A1C 才是医生使用的准确数值。" },
        { q: "应该用哪个平均血糖？", a: "使用一天中不同时间多次读数的平均值效果最好，单次读数并不具代表性。" },
      ],
    },
    "bmi": {
      desc: "免费的 BMI 计算器，支持美制和公制单位。查看你的身体质量指数及其体重类别，解释简单明了。",
      faq: [
        { q: "BMI 对每个人都准确吗？", a: "BMI 是一种快速筛查，而非体脂测量。肌肉发达的人可能偏高，它也无法反映脂肪分布。请结合其他指标一起使用。" },
        { q: "健康的 BMI 是多少？", a: "对大多数成年人，18.5–24.9 被视为正常范围，但健康体重取决于整体健康状况，请咨询医生。" },
      ],
    },
    "blood-pressure": {
      desc: "免费的血压分类检查器（ACC/AHA）。输入收缩压和舒张压，了解你的读数意味着什么以及下一步该怎么做。",
      faq: [
        { q: "正常血压是多少？", a: "对大多数成年人，低于 120/80 mmHg 为正常。收缩压 120–129 为“偏高”，130/80 或以上为高血压。" },
        { q: "一次读数偏高需要担心吗？", a: "单次读数可能受压力、咖啡因或活动影响。平静休息后再测；若持续偏高或感到不适，请联系医生。" },
      ],
    },
    "egfr": {
      desc: "免费的 eGFR 肾功能计算器，采用不含种族因素的 CKD-EPI 2021 公式，根据肌酐、年龄和性别估算肾功能。",
      faq: [
        { q: "eGFR 能告诉我什么？", a: "它估算肾脏过滤血液的能力。通常越高越好；单个数值不是诊断，肾脏健康需要长期评估。" },
        { q: "为什么不使用种族？", a: "2021 年 CKD-EPI 公式不再使用种族，遵循当前指南，使估算更公平、更一致。" },
      ],
    },
    "creatinine-clearance": {
      desc: "免费的肌酐清除率计算器（Cockcroft-Gault），根据年龄、体重、肌酐和性别估算。用于肾功能与药物剂量的教育性估算。",
      faq: [
        { q: "它与 eGFR 有何不同？", a: "Cockcroft-Gault 使用你的实际体重，常用于药物剂量；而 eGFR 按体型标准化，用于肾病分期。" },
        { q: "应该输入哪个体重？", a: "本工具使用实际体重。临床医生在用结果计算剂量时可能会按体型进行调整。" },
      ],
    },
    "cholesterol-risk": {
      desc: "免费的胆固醇风险工具：查看你的总胆固醇/HDL 比值以及常见的心脏风险因素，用通俗语言解释。",
      faq: [
        { q: "总胆固醇与 HDL 的比值多少算好？", a: "越低越好。大约低于 3.5 较为理想；比值越高提示心血管风险越大。它只是一个信号，而非完整评分。" },
        { q: "这能给出我的 ASCVD 风险吗？", a: "不能。若需正式的 10 年心脏病风险估算，请向医生咨询 ASCVD 风险计算器，它会使用更多健康数据。" },
      ],
    },
    "ldl": {
      desc: "免费的 LDL 胆固醇计算器，采用 Friedewald 公式，根据总胆固醇、HDL 和甘油三酯计算。教育性、即时。",
      faq: [
        { q: "Friedewald LDL 何时不适用？", a: "当甘油三酯达到 400 mg/dL（4.5 mmol/L）或以上时，其结果不可靠。此时应要求直接测量 LDL。" },
        { q: "LDL 应控制在多少？", a: "目标取决于你的整体心脏风险。许多人以低于 100 mg/dL 为目标，风险更高者更低——请与医生讨论。" },
      ],
    },
    "non-hdl": {
      desc: "免费的非 HDL 胆固醇计算器，根据总胆固醇和 HDL 计算。一个能涵盖所有“坏”胆固醇的实用治疗目标。",
      faq: [
        { q: "为什么非 HDL 有用？", a: "它涵盖了所有可能在动脉中堆积的胆固醇颗粒，而不仅是 LDL，因此可能是更好的治疗目标，尤其在甘油三酯偏高时。" },
        { q: "如何计算？", a: "非 HDL 胆固醇就是你的总胆固醇减去 HDL（“好”）胆固醇。" },
      ],
    },
    "target-heart-rate": {
      desc: "免费的目标心率计算器。按年龄找到你的中等和高强度运动心率区间（可选 Karvonen 方法）。",
      faq: [
        { q: "这些心率区间如何计算？", a: "最大心率估算为 220 减去年龄。中等强度为 50–70%，高强度为 70–85%。加入静息心率则采用更个性化的 Karvonen 方法。" },
        { q: "这些区间准确吗？", a: "不准确——它们是按年龄的估算。体能、药物和健康状况都有影响。若感到不适请放慢或停止。" },
      ],
    },
    "due-date": {
      desc: "免费的预产期计算器，采用 Naegele 法则，从末次月经推算。即时估算预产期和当前孕周。",
      faq: [
        { q: "预产期如何估算？", a: "在末次月经第一天加 280 天（40 周），假设月经周期为 28 天。超声检查能给出更精确的日期。" },
        { q: "有多准确？", a: "对周期规律者是不错的估算，但只有约二十分之一的宝宝在预产期当天出生。医生在超声后可能会调整。" },
      ],
    },
    "medication-dose": {
      desc: "免费的按体重给药计算器（mg/kg），可选最大单次剂量上限。仅为教育性计算——请务必向专业人士确认。",
      faq: [
        { q: "用它给真实药物定量安全吗？", a: "这只是通用的 mg/kg 计算，仅供教育。给药前请务必向药师或医生确认正确的药物、剂量、频次和产品。" },
        { q: "最大剂量的作用是什么？", a: "如果你输入单次上限，结果不会超过它——适用于无论体重都有封顶的药物。" },
      ],
    },
    "ideal-body-weight": {
      desc: "免费的理想体重计算器（Devine 公式），根据身高和性别计算，以 kg 和 lb 显示，作为大致的临床参考。",
      faq: [
        { q: "理想体重有什么用？", a: "它是一些药物剂量和临床估算中使用的大致参考。真正的健康体重因体格、肌肉和身体成分而异。" },
        { q: "我应该追求这个确切数值吗？", a: "不一定——它是基于公式的估算，而非个人目标。请与医生讨论健康的体重范围。" },
      ],
    },
    "waist-height-ratio": {
      desc: "免费的腰高比（WHtR）计算器——通过腰围和身高快速评估中心性脂肪和心脏健康风险。",
      faq: [
        { q: "健康的腰高比是多少？", a: "让腰围小于身高的一半（比值低于 0.5）是一个简单且广泛使用的心脏健康目标。" },
        { q: "为什么要量腰围而不仅看 BMI？", a: "腰围反映器官周围储存的脂肪，风险更高。腰高比补充了 BMI 可能忽略的有用信息。" },
      ],
    },
    "pediatric-fever": {
      desc: "免费的儿童退烧给药计算器（对乙酰氨基酚和布洛芬），按体重计算，现在还提供常见液体浓度以得出精确的毫升数。",
      faq: [
        { q: "我可以给孩子服用多少对乙酰氨基酚或布洛芬？", a: "剂量按体重计算（对乙酰氨基酚约 15 mg/kg，布洛芬约 10 mg/kg）。选择产品浓度即可看到精确毫升数——再向儿科医生或药师确认。" },
        { q: "如何量取液体？", a: "请务必使用药品自带的注射器或量杯，绝不要用厨房勺子，也不要同时使用含相同药物的产品。" },
      ],
    },
  },

  vi: {
    "a1c-to-glucose": {
      desc: "Máy tính miễn phí đổi A1C sang đường huyết trung bình (eAG). Hiểu A1C của bạn có ý nghĩa gì với đường huyết hằng ngày, bằng ngôn ngữ dễ hiểu. Riêng tư, tức thì.",
      faq: [
        { q: "Đường huyết trung bình ước tính (eAG) là gì?", a: "eAG chuyển phần trăm A1C của bạn thành con số đường huyết trung bình (mg/dL hoặc mmol/L) phản ánh 2–3 tháng qua, dễ so sánh với các lần đo tại nhà." },
        { q: "A1C càng thấp có luôn tốt hơn không?", a: "Thường nghĩa là kiểm soát dài hạn tốt hơn, nhưng mục tiêu tùy từng người. Số quá thấp có thể là hạ đường huyết. Hãy trao đổi với bác sĩ về A1C mục tiêu." },
      ],
    },
    "glucose-to-a1c": {
      desc: "Công cụ miễn phí ước tính A1C từ đường huyết. Đổi đường huyết trung bình thành phần trăm A1C gần đúng. Mang tính giáo dục, riêng tư, tức thì.",
      faq: [
        { q: "Có thể thay xét nghiệm A1C bằng ước tính này không?", a: "Không. Đây là ước tính mang tính giáo dục từ đường huyết trung bình; A1C xét nghiệm từ máu mới là giá trị chính xác bác sĩ dùng." },
        { q: "Nên dùng đường huyết trung bình nào?", a: "Hãy dùng trung bình của nhiều lần đo vào các thời điểm khác nhau trong ngày để ước tính tốt nhất; một lần đo không đại diện." },
      ],
    },
    "bmi": {
      desc: "Máy tính BMI miễn phí với đơn vị Mỹ và hệ mét. Tìm chỉ số khối cơ thể và phân loại cân nặng, giải thích đơn giản. Riêng tư, tức thì.",
      faq: [
        { q: "BMI có chính xác cho mọi người không?", a: "BMI là sàng lọc nhanh, không phải đo mỡ cơ thể. Người nhiều cơ có thể cao, và nó không cho biết mỡ nằm ở đâu. Hãy dùng cùng các chỉ số khác." },
        { q: "BMI khỏe mạnh là bao nhiêu?", a: "Với hầu hết người lớn, 18,5–24,9 được xem là khoảng bình thường, nhưng cân nặng khỏe mạnh tùy sức khỏe tổng thể — hãy hỏi bác sĩ." },
      ],
    },
    "blood-pressure": {
      desc: "Công cụ kiểm tra phân loại huyết áp miễn phí (ACC/AHA). Nhập huyết áp tâm thu và tâm trương để biết chỉ số của bạn có ý nghĩa gì và cần làm gì.",
      faq: [
        { q: "Huyết áp bình thường là bao nhiêu?", a: "Dưới 120/80 mmHg được xem là bình thường với hầu hết người lớn. Tâm thu 120–129 là 'tăng nhẹ', và 130/80 trở lên là huyết áp cao." },
        { q: "Một lần đo cao có đáng lo không?", a: "Một lần đo có thể bị ảnh hưởng bởi căng thẳng, caffeine hay vận động. Hãy đo lại khi thư giãn; nếu vẫn cao hoặc thấy khó chịu, hãy liên hệ bác sĩ." },
      ],
    },
    "egfr": {
      desc: "Máy tính chức năng thận eGFR miễn phí dùng công thức CKD-EPI 2021 không phân biệt chủng tộc, ước tính từ creatinine, tuổi và giới tính.",
      faq: [
        { q: "eGFR cho tôi biết điều gì?", a: "Nó ước tính khả năng lọc máu của thận. Cao hơn thường tốt hơn; một giá trị đơn lẻ không phải chẩn đoán — sức khỏe thận được đánh giá theo thời gian." },
        { q: "Vì sao không dùng chủng tộc?", a: "Công thức CKD-EPI 2021 không dùng chủng tộc, theo hướng dẫn hiện hành để ước tính công bằng và nhất quán hơn." },
      ],
    },
    "creatinine-clearance": {
      desc: "Máy tính độ thanh thải creatinine miễn phí (Cockcroft-Gault) từ tuổi, cân nặng, creatinine và giới tính. Ước tính mang tính giáo dục cho chức năng thận và liều thuốc.",
      faq: [
        { q: "Khác gì so với eGFR?", a: "Cockcroft-Gault dùng cân nặng thực tế và thường dùng để tính liều thuốc, còn eGFR chuẩn hóa theo kích thước cơ thể để phân giai đoạn bệnh thận." },
        { q: "Nên nhập cân nặng nào?", a: "Công cụ này dùng cân nặng thực tế. Bác sĩ có thể điều chỉnh theo kích thước cơ thể khi dùng kết quả để tính liều." },
      ],
    },
    "cholesterol-risk": {
      desc: "Công cụ nguy cơ cholesterol miễn phí: xem tỷ lệ cholesterol toàn phần/HDL cùng các yếu tố nguy cơ tim mạch thường gặp, giải thích dễ hiểu.",
      faq: [
        { q: "Tỷ lệ toàn phần/HDL tốt là bao nhiêu?", a: "Càng thấp càng tốt. Dưới khoảng 3,5 là thuận lợi; tỷ lệ cao hơn gợi ý nguy cơ tim mạch lớn hơn. Đây là một tín hiệu, không phải điểm số đầy đủ." },
        { q: "Công cụ này có cho nguy cơ ASCVD không?", a: "Không. Để ước tính chính thức nguy cơ tim mạch 10 năm, hãy hỏi bác sĩ về công cụ nguy cơ ASCVD, dùng nhiều dữ liệu sức khỏe hơn." },
      ],
    },
    "ldl": {
      desc: "Máy tính cholesterol LDL miễn phí dùng công thức Friedewald từ cholesterol toàn phần, HDL và triglyceride. Mang tính giáo dục, tức thì.",
      faq: [
        { q: "Khi nào LDL Friedewald không còn đúng?", a: "Nó kém tin cậy khi triglyceride từ 400 mg/dL (4,5 mmol/L) trở lên. Khi đó hãy yêu cầu đo LDL trực tiếp." },
        { q: "Nên đặt mục tiêu LDL bao nhiêu?", a: "Mục tiêu tùy nguy cơ tim mạch tổng thể. Nhiều người nhắm dưới 100 mg/dL, thấp hơn nếu nguy cơ cao — hãy trao đổi với bác sĩ." },
      ],
    },
    "non-hdl": {
      desc: "Máy tính cholesterol non-HDL miễn phí từ cholesterol toàn phần và HDL. Một mục tiêu điều trị hữu ích bao gồm toàn bộ cholesterol 'xấu'.",
      faq: [
        { q: "Vì sao non-HDL hữu ích?", a: "Nó bao gồm mọi hạt cholesterol có thể tích tụ trong động mạch, không chỉ LDL, nên có thể là mục tiêu điều trị tốt hơn — nhất là khi triglyceride cao." },
        { q: "Cách tính thế nào?", a: "Cholesterol non-HDL đơn giản là cholesterol toàn phần trừ cholesterol HDL ('tốt')." },
      ],
    },
    "target-heart-rate": {
      desc: "Máy tính nhịp tim mục tiêu miễn phí. Tìm vùng nhịp tim tập luyện vừa và mạnh theo tuổi (có tùy chọn phương pháp Karvonen).",
      faq: [
        { q: "Các vùng nhịp tim được tính thế nào?", a: "Nhịp tim tối đa ước tính bằng 220 trừ tuổi. Vừa là 50–70% và mạnh là 70–85%. Thêm nhịp tim lúc nghỉ sẽ dùng phương pháp Karvonen cá nhân hơn." },
        { q: "Các vùng này có chính xác không?", a: "Không — chúng là ước tính theo tuổi. Thể lực, thuốc và tình trạng sức khỏe đều ảnh hưởng. Hãy chậm lại hoặc dừng nếu thấy khó chịu." },
      ],
    },
    "due-date": {
      desc: "Máy tính ngày dự sinh miễn phí dùng quy tắc Naegele từ kỳ kinh cuối. Ước tính ngày dự sinh và tuổi thai hiện tại ngay lập tức.",
      faq: [
        { q: "Ngày dự sinh được ước tính thế nào?", a: "Cộng 280 ngày (40 tuần) vào ngày đầu kỳ kinh cuối, giả định chu kỳ 28 ngày. Siêu âm cho ngày chính xác hơn." },
        { q: "Độ chính xác ra sao?", a: "Đây là ước tính tốt cho chu kỳ đều, nhưng chỉ khoảng 1/20 em bé sinh đúng ngày dự sinh. Bác sĩ có thể điều chỉnh sau khi siêu âm." },
      ],
    },
    "medication-dose": {
      desc: "Máy tính liều theo cân nặng miễn phí (mg/kg) với giới hạn liều tối đa tùy chọn. Chỉ là phép tính giáo dục — luôn xác nhận với chuyên gia.",
      faq: [
        { q: "Dùng nó để tính liều thuốc thật có an toàn không?", a: "Đây chỉ là phép tính mg/kg tổng quát mang tính giáo dục. Luôn xác nhận đúng thuốc, liều, tần suất và sản phẩm với dược sĩ hoặc bác sĩ trước khi dùng." },
        { q: "Liều tối đa có tác dụng gì?", a: "Nếu bạn nhập giới hạn mỗi liều, kết quả sẽ không vượt quá — hữu ích cho thuốc có trần bất kể cân nặng." },
      ],
    },
    "ideal-body-weight": {
      desc: "Máy tính cân nặng lý tưởng miễn phí (công thức Devine) từ chiều cao và giới tính. Một tham chiếu lâm sàng gần đúng, hiển thị kg và lb.",
      faq: [
        { q: "Cân nặng lý tưởng dùng để làm gì?", a: "Đây là tham chiếu gần đúng dùng trong một số cách tính liều và ước tính lâm sàng. Cân nặng khỏe mạnh thực tế thay đổi theo vóc dáng, cơ và thành phần cơ thể." },
        { q: "Tôi có nên nhắm đúng con số này không?", a: "Không nhất thiết — đây là ước tính theo công thức, không phải mục tiêu cá nhân. Hãy trao đổi với bác sĩ về khoảng cân nặng khỏe mạnh." },
      ],
    },
    "waist-height-ratio": {
      desc: "Máy tính tỷ lệ vòng eo trên chiều cao (WHtR) miễn phí — cách nhanh để kiểm tra mỡ trung tâm và nguy cơ tim mạch từ vòng eo và chiều cao.",
      faq: [
        { q: "Tỷ lệ vòng eo/chiều cao khỏe mạnh là bao nhiêu?", a: "Giữ vòng eo dưới một nửa chiều cao (tỷ lệ dưới 0,5) là mục tiêu đơn giản, phổ biến cho sức khỏe tim mạch." },
        { q: "Vì sao đo vòng eo thay vì chỉ BMI?", a: "Vòng eo phản ánh mỡ quanh nội tạng, mang nguy cơ cao hơn. WHtR bổ sung thông tin hữu ích mà BMI có thể bỏ sót." },
      ],
    },
    "pediatric-fever": {
      desc: "Máy tính liều hạ sốt cho trẻ miễn phí (acetaminophen và ibuprofen) theo cân nặng — nay có nồng độ dạng lỏng thường gặp để ra số mL chính xác.",
      faq: [
        { q: "Tôi có thể cho con dùng bao nhiêu acetaminophen hoặc ibuprofen?", a: "Liều theo cân nặng (khoảng 15 mg/kg acetaminophen, 10 mg/kg ibuprofen). Chọn nồng độ sản phẩm để thấy số mL chính xác — rồi xác nhận với bác sĩ nhi hoặc dược sĩ." },
        { q: "Đong thuốc lỏng thế nào?", a: "Luôn dùng ống bơm hoặc cốc đi kèm thuốc, không dùng thìa ăn, và không kết hợp các sản phẩm chứa cùng hoạt chất." },
      ],
    },
  },
};
